/**
 * NOTE: Not unit tested due to too much mocking.
 */

import router, { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'

export const useScrollToTopOnRouteChange = (): {
	mainRef: React.RefObject<HTMLDivElement>
} => {
	const { events } = useRouter()

	const mainRef = useRef<HTMLDivElement>(null)

	const currentUrlRef = useRef<string | null>(null)

	useEffect(() => {
		if (typeof document === 'undefined') {
			return
		}

		const mainElement = mainRef.current

		if (!mainElement) {
			return
		}

		const handleRouteChange = (
			url: string,
			{ shallow }: { shallow: boolean }
		): void => {
			/**
			 * Don't scroll for query parameter changes (shallow routing)
			 */
			if (shallow) {
				return
			}

			/**
			 * Don't scroll if the route is a search page (we hijack this elsewhere)
			 */
			const isSearch = url.startsWith('/track/searchkeyword')

			/**
			 * Don't scroll if the route is determined by tab changes (e.g. playlist hub and individual collection pages)
			 */
			const playlistHubRouteRegex = /^\/playlist-hub\/.+/
			const collectionsRouteRegex = /^\/collections\/.+/

			const isStillOnPlaylistHub =
				currentUrlRef.current?.match(playlistHubRouteRegex) &&
				url.match(playlistHubRouteRegex)

			const isSameCollection =
				currentUrlRef.current?.match(collectionsRouteRegex) &&
				url.match(collectionsRouteRegex)

			const shouldScrollToTop =
				!isSearch && !isStillOnPlaylistHub && !isSameCollection

			currentUrlRef.current = url

			if (shouldScrollToTop) {
				mainElement.scrollTo(0, 0)
			}
		}

		events.on('routeChangeComplete', handleRouteChange)

		return () => {
			events.off('routeChangeComplete', handleRouteChange)
		}
	}, [events])

	useEffect(() => {
		currentUrlRef.current = router.pathname
	}, [])

	return {
		mainRef,
	}
}
